import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, HomeIcon, BotIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const steps = [{
  icon: ZapIcon,
  title: 'Download instantly',
  text: 'Complete your purchase and get immediate access to all 100+ step-by-step PDF guides — no waiting and no shipping.',
  tone: 'bg-sky-light text-sky',
  numberTone: 'bg-sky'
}, {
  icon: HomeIcon,
  title: 'Gather simple materials',
  text: 'Every project uses everyday items you already have at home — cardboard, tape, rubber bands, and bottle caps. No special purchases needed.',
  tone: 'bg-sunshine-light text-ink',
  numberTone: 'bg-sunshine text-ink'
}, {
  icon: BotIcon,
  title: 'Build & learn together',
  text: 'Follow the illustrated guide with your child and watch them create real working robots — and beam with pride.',
  tone: 'bg-coral-light text-coral',
  numberTone: 'bg-coral text-ink'
}];
export function HowItWorks() {
  return <section className="w-full bg-cream py-16 sm:py-24" data-id="element-96" data-mp="2rmpj2a72kptb">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-97" data-mp="2mml6gv9a8f8d">
        <SectionHeading eyebrow="How it works" title={<>From download to first robot in 3 simple steps</>} subtitle="No technical knowledge, special tools, or expensive materials. Just download, gather a few things from home, and get started." data-id="element-98" data-mp="2mo608inrvu56" />
        <div className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-99" data-mp="3ab48it1qnvs0">
          {steps.map((s, i) => <motion.div key={s.title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="relative rounded-3xl border border-ink/10 bg-white p-8" data-id="element-100" data-mp="369iswzxtl3e4" data-mpi={i}>
              <span className={`absolute -top-4 left-8 flex h-9 w-9 items-center justify-center rounded-full font-display text-lg font-bold ${s.numberTone}`} data-id="element-101" data-mp="3l1tocgqdvcml">
                {i + 1}
              </span>
              <span className={`flex h-14 w-14 items-center justify-center rounded-2xl ${s.tone}`} data-id="element-102" data-mp="3u2hy2z8quqto">
                <s.icon className="h-7 w-7" aria-hidden="true" data-id="element-103" data-mp="7synvfgznbf3" />
              </span>
              <h3 className="mt-5 font-display text-xl font-bold text-ink" data-id="element-104" data-mp="7qulj1yqmkgx">
                {s.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-ink/60" data-id="element-105" data-mp="hiqoaqbrqyrh">
                {s.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}